import type { CustomVoice } from "@davi-ai/retorik-framework";
import React, { useEffect, useState } from "react";
import voiceChangeAction from "../../redux/Actions/Kiosk/voiceChangeAction";
import { useVoice } from "../../redux/Hooks";
import { useDispatchKiosk } from "../../redux/Hooks/Kiosk/useDispatchKiosk";
import { useLocale } from "@davi-ai/retorik-framework";
import translation from '../../translations/subMenuItems.json';
import commonTranslation from '../../translations/common.json';
import Button from "../Common/Button";
import Select from "../Common/Select";

const LanguageSettings = (): JSX.Element => {
  const locale = useLocale();
  const voiceConfig: CustomVoice | undefined = useVoice();
  const dispatch = useDispatchKiosk();
  const [voice, setVoice] = useState<string | undefined>(voiceConfig?.voice);

  useEffect(() => {
    setVoice(voiceConfig?.voice);
  }, [voiceConfig?.voice]);

  const save = () => {
    dispatch(voiceChangeAction({ ...voiceConfig, voice }));
  };

  const handleVoiceChange = (value: string): void => {
    setVoice(value === "auto" ? undefined : value)
  };

  return (
    <div className="w-full flex flex-col gap-4 mt-6">
      <h2 className="font-semibold text-lg">
        {translation[locale]?.language.voice || translation["fr-FR"].language.voice}
      </h2>
      <Select
        options={[
          {
            label: translation[locale]?.language.option1 || translation["fr-FR"].language.option1,
            value: "auto",
          },
          {
            label: translation[locale]?.language.option2 || translation["fr-FR"].language.option2,
            value: "JennyMultilingual",
          },
        ]}
        onChange={handleVoiceChange}
        currentValue={voice ? voice : "auto"}
      />
      <Button label={commonTranslation[locale]?.save || commonTranslation["fr-FR"].save} onClick={save}>
        {commonTranslation[locale]?.save || commonTranslation["fr-FR"].save}
      </Button>
    </div>
  );
};

export default LanguageSettings;
